import React from 'react';

import { Button } from '@mantine/core';
import { IconCloudUpload } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface SaveButtonProps {
  onSaveChanges: () => void;
}

export function SaveButton({ onSaveChanges }: SaveButtonProps) {
  const { t } = useTranslation();

  return (
    <Button
      size="xs"
      leftIcon={<IconCloudUpload size={16} />}
      onClick={onSaveChanges}
      radius="xl"
      sx={(theme) => ({
        height: '32px',
        backgroundColor: theme.colors.dark[6],
        '&:hover': { backgroundColor: theme.colors.gray[8] }
      })}>
      {t('SMART_EDITOR.SAVE')}
    </Button>
  );
}
